import { defineAsyncComponent, type Component } from 'vue'

export type InteractiveComponentKey =
  | 'summary'
  | 'meetingView'
  | 'meetingForm'
  | 'contactView'
  | 'contactForm'
  | 'taskView'
  | 'taskForm'
  | 'emailView'
  | 'noteView'
  | 'noteForm'
  | 'resourceView'
  | 'resourceForm'


  export const componentMap: Record<InteractiveComponentKey, Component> = {
    summary: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    meetingView: defineAsyncComponent(() => import('@/components/calendar/MeetingPanel.vue')),
    meetingForm: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    contactView: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    contactForm: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    taskView: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    taskForm: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    emailView: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    noteView: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    noteForm: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    resourceView: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
    resourceForm: defineAsyncComponent(() => import('@/components/calendar/Summary.vue')),
  }